import React, { useState, useCallback, useEffect } from "react";
import { default as ReactSelect, components } from "react-select";

type DropdownTypes = {
  options:
    | []
    | { value: string; label: string }[]
    | { label: string; options: { value: string; label: string }[] }[];
  handleChange: any;
  isMulti?: boolean;
  placeholder: string;
  label?: string;
  value?: any;
  isClearable?: boolean;
  hideSelectedOptions?: boolean;
  error?: string | undefined;
  touched?: boolean | number;
  isDisabled?: boolean;
  onCreateNew?: (inputValue?: string) => void;
  createNewLabel?: string;
  isCreateNew?: boolean;
  isLoading?: boolean;
  inputInside?: boolean;
  name?: string;
  openModal?: boolean;
  required?: boolean;
};

export default function Dropdown({
  options,
  handleChange,
  isMulti = false,
  placeholder,
  label,
  value = isMulti ? [] : null,
  isClearable,
  hideSelectedOptions,
  error,
  touched,
  isDisabled,
  onCreateNew,
  createNewLabel = "Create New",
  isCreateNew,
  isLoading,
  inputInside,
  openModal,
  required,
}: DropdownTypes) {
  const [containerHeight, setContainerHeight] = useState("35px");
  const [optionsDropdown, setOptionsDropdown] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    // Initialize with empty array if options is undefined
    const baseOptions = options || [];

    // Always set options, even if base options are empty
    setOptionsDropdown([...baseOptions]);
  }, [options, createNewLabel]);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const updateContainerHeight = useCallback(
    (selectedOptions) => {
      if (isMulti && selectedOptions && selectedOptions.length > 0) {
        const newHeight = `${Math.max(35, selectedOptions.length * 12 + 10)}px`;
        setContainerHeight(newHeight);
      } else {
        setContainerHeight("35px");
      }
    },
    [isMulti]
  );

  const customHandleChange = (selectedOptions) => {
    updateContainerHeight(selectedOptions);
    handleChange(selectedOptions);
  };

  const handleKeyDown = (event) => {
    if (!inputValue) return;

    if (event.key === "Enter" && isCreateNew) {
      handleCreateNew();
      // const newOption = { value: inputValue, label: inputValue };
      // if (!optionsDropdown.some((opt: any) => opt.value === inputValue)) {
      //   customHandleChange([...(value || []), newOption]);
      // }
      // customHandleChange([...(value || []), newOption]);
      // setInputValue("");
      event.preventDefault();
    }
  };

  const Option = (props: any) => {
    return isMulti ? (
      <components.Option {...props}>
        <div className="flex items-center whitespace-nowrap">
          <input
            type="checkbox"
            className="mr-2 border border-[#A5A5A6] rounded-4px"
            checked={props.isSelected}
            style={{
              accentColor: "#4D998B",
            }}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </div>
      </components.Option>
    ) : (
      <components.Option {...props}>
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const handleCreateNew = () => {
    onCreateNew?.(inputValue);
    setInputValue("");
  };

  const CustomMenuList = (props) => {
    const { children } = props;

    return (
      <components.MenuList {...props}>
        {isCreateNew &&
          // !Array.isArray(children)
          (!openModal ? inputValue : true) && (
            <div className="px-3 py-2 hover:bg-gray-25 cursor-pointer">
              <button
                className="text-sm text-customGreen-primary text-left"
                onClick={handleCreateNew}
                type="button"
              >
                + {createNewLabel}
              </button>
            </div>
          )}

        {children}
      </components.MenuList>
    );
  };

  const showError = touched && error;

  return (
    <div>
      {label && (
        <span className="text-sm mb-2  text-black-secondary flex font-medium">
          {label}
          {required && <span className="px-1 text-red-500">*</span>}
        </span>
      )}
      <span className="flex">
        <ReactSelect
          menuPlacement="auto"
          options={optionsDropdown}
          isDisabled={isDisabled}
          styles={{
            container: (styles) => ({
              ...styles,
              width: "100%",
              fontSize: "16px",
              textAlign: "left",
              boxShadow: inputInside
                ? "none"
                : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              outline: "none",
            }),
            control: (styles, { isFocused, isDisabled }) => ({
              ...styles,
              width: "100%",
              border: showError
                ? "1px solid #FDA29B"
                : inputInside
                  ? "none"
                  : "1px solid #A5A5A6",
              borderRadius: "6px",
              minHeight: "42px",
              height: "auto",
              borderColor: inputInside
                ? "white"
                : isFocused
                  ? "#99C5BD"
                  : styles.borderColor,
              boxShadow: inputInside
                ? ""
                : isFocused
                  ? "0 0 0 2px #E5F0EF"
                  : "none",
              backgroundColor: isDisabled ? "#ecede9" : styles.backgroundColor,
              "&:hover": {
                borderColor: "#99C5BD",
                boxShadow: "#E5F0EF",
              },
              "&>*:first-child": {
                paddingLeft: isMulti ? "8px" : "12px",
                paddingRight: isMulti ? "8px" : "12px",
              },
            }),
            indicatorsContainer: (styles) => ({
              ...styles,
              display: "-webkit-box",
              // height: location ? "42px" : containerHeight,
              height: "42px",
            }),
            option: (styles, { isFocused, isSelected }) => {
              return {
                ...styles,
                backgroundColor: isSelected
                  ? "#F8F8F7"
                  : isFocused
                    ? "#F8F8F7"
                    : "",
                color: isSelected ? "#000" : "#000",
                fontSize: "16px",
                cursor: "pointer",
                "&:active": {
                  backgroundColor: isFocused ? "#f2f8f7" : "transparent",
                },
              };
            },
            multiValue: (styles) => ({
              ...styles,
              borderRadius: "999px",
              paddingLeft: "2px",
              paddingRight: "2px",
              flex: "0 0 auto",
              color: "#338A7B",
              backgroundColor: "#E5F0EF",

              // display: location  ? "none" : "flex",
            }),
            multiValueRemove: (styles) => ({
              ...styles,
              //  padding: "0 0",
              // transform: "scale(1)",
              fontWeight: "normal",
              color: "#338A7B",
              "&:hover": {
                backgroundColor: "transparent",
              },

              //  display: location ? "none" : "flex",
            }),
            multiValueLabel: (styles) => ({
              ...styles,
              color: "#338A7B",
              fontSize: "14px",
              //   display: location ? "none" : "flex",
            }),
            valueContainer: (styles) => ({
              ...styles,
              //  height: location ? "auto" : containerHeight,
              //  maxHeight: location ? "auto" : containerHeight,
              height: "auto",
              overflowY: "auto",
              overflowX: "auto",
              maxHeight: "auto",
              // padding: "2px 8px",
              // display: "flex",
              // flexWrap: "wrap",
              // maxHeight: "auto",
            }),
            // placeholder: (styles) => ({
            //   ...styles,
            //   position: "absolute",
            //   display: "block",
            //   color: "#6B7280",
            // }),
            input: (styles) => ({
              ...styles,
              backgroundColor: isDisabled ? "#ecede9" : styles.backgroundColor,
              borderColor: isDisabled ? "#d1d5db" : styles.borderColor,
            }),
            dropdownIndicator: (base) => ({
              ...base,
              paddingLeft: "0px",
              color: "#787879",
            }),
          }}
          value={value}
          isMulti={isMulti}
          isClearable={isClearable}
          closeMenuOnSelect={!isMulti}
          controlShouldRenderValue={true}
          hideSelectedOptions={hideSelectedOptions ? true : false}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          onKeyDown={handleKeyDown}
          components={{
            Option,
            MenuList: CustomMenuList,
            IndicatorSeparator: () => null,
          }}
          placeholder={placeholder}
          onChange={customHandleChange}
          isLoading={isLoading}
        />
      </span>
      {/* {location && isMulti && value && value.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2 mt-2">
          {(Array.isArray(value) ? value : [value]).map((option: any) => (
            <div
              key={option.value}
              className="flex items-center gap-1 px-3 py-1 rounded-full bg-[#E5F0EF] text-[#338A7B]"
            >
              <span className="text-sm">{option.label}</span>
              {isMulti && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const newValue = Array.isArray(value)
                      ? value.filter((v: any) => v.value !== option.value)
                      : null;
                    customHandleChange(newValue);
                  }}
                  className="text-[#338A7B] hover:text-red-500"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      )} */}
      {showError && <p className="text-base text-error-500">{error}</p>}
    </div>
  );
}
